module.exports = __webpack_public_path__ + "static/media/img16.f8c72379.jpg";